import { useEffect, useState } from 'react';

/**
 * Costruisce un object URL a partire dai byte (arraybuffer) di un'immagine e lo
 * revoca al cleanup, evitando memory leak. Passare `clear: true` per forzare
 * l'assenza di immagine (es. query in errore o immagine eliminata): react-query
 * mantiene l'ultimo `data` valido anche dopo un refetch fallito.
 */
export function useImageObjectUrl(
  imageBytes: ArrayBuffer | undefined,
  contentType: string | undefined,
  clear = false,
): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (clear || !imageBytes || imageBytes.byteLength === 0) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(
      new Blob([imageBytes], { type: contentType }),
    );
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [imageBytes, contentType, clear]);

  return url;
}
